module.exports = __webpack_public_path__ + "static/pres-1f1199b0239bfdcdf1c2874e0fdb002a.jpg";